const localizedName = (item = {}, arabic = false) =>
  (arabic && (item.ar_name || item.name_ar || item.arabic_name || item.ar_title)) ||
  item.name || item.title || item.value || "";
const finiteNumber = (value, fallback = 0) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : fallback;
};

export const getCartLineDetails = (
  item = {},
  product = {},
  language = "english",
) => {
  const arabic = language === "arabic";
  const details = [];
  Object.entries(item.options || {}).forEach(([groupId, selection = {}]) => {
    const group = (Array.isArray(product.options) ? product.options : []).find(
      (option) => `${option.id}` === `${groupId}`,
    );
    Object.entries(
      selection?.selectedOptions || selection?.selected_options || {},
    ).forEach(([choiceId, selected = {}]) => {
      const choice = (Array.isArray(group?.choices) ? group.choices : []).find(
        (option) => `${option.id}` === `${choiceId}`,
      );
      const name = localizedName(choice || selected, arabic);
      const quantity = finiteNumber(selected.quantity, 1);
      if (name) details.push(quantity > 1 ? `${name} × ${quantity}` : name);
    });
  });
  Object.values(item.extraFields || item.extra_fields || {}).forEach((field) => {
    const name = localizedName(field, arabic);
    const value = `${field?.value ?? field ?? ""}`.trim();
    if (value) details.push(name ? `${name}: ${value}` : value);
  });
  if (item.special_request)
    details.push(
      `${arabic ? "طلب خاص" : "Special request"}: ${item.special_request}`,
    );
  return details;
};

// Use structured variant metadata, never split merchant-authored product names.
export const getCartProductPresentation = (meta = {}, language = "english") => {
  const arabic = language === "arabic";
  const product = meta.product || meta.item || {};
  const values = product.variant_values || meta.item?.variant_values;
  const variants = (Array.isArray(values) ? values : [])
    .map((value) => (arabic && value.variant_value_ar) || value.variant_value)
    .filter(Boolean);
  const parentName = variants.length && localizedName(meta.parentProduct || {}, arabic);
  return {
    name: parentName || meta.displayName || localizedName(product, arabic),
    variants: variants.join(" · "),
  };
};
